import React from "react";

const STATUS_STYLES = {
    active: "bg-forest text-parchment border-forest",
    verified: "bg-forest text-parchment border-forest",
    signed: "bg-slate2 text-parchment border-slate2",
    unconfigured: "bg-ink-muted text-parchment border-ink-muted",
    unverified: "bg-parchment-secondary text-ink-muted border-parchment-rule",
    unverifiable: "bg-parchment-secondary text-ink-muted border-parchment-rule",
    unsigned: "bg-parchment-secondary text-ink-muted border-parchment-rule",
    auth_rejected: "bg-oxblood text-parchment border-oxblood",
    verification_failed: "bg-oxblood text-parchment border-oxblood",
    unreachable: "bg-ochre text-parchment border-ochre",
    node_error: "bg-ochre text-parchment border-ochre",
    referral_open: "bg-ochre text-parchment border-ochre",
    awaiting_broker_evidence: "bg-slate2 text-parchment border-slate2",
    underwriter_review: "bg-slate2 text-parchment border-slate2",
    awaiting_manager_authority: "bg-oxblood text-parchment border-oxblood",
    decided: "bg-forest text-parchment border-forest",
    approve: "bg-forest text-parchment border-forest",
    decline: "bg-oxblood text-parchment border-oxblood",
    modify: "bg-slate2 text-parchment border-slate2",
    refer_higher_authority: "bg-ochre text-parchment border-ochre",
};

const LABEL_OVERRIDES = {
    awaiting_broker_evidence: "Awaiting Evidence",
    awaiting_manager_authority: "Awaiting Manager Authority",
    underwriter_review: "Underwriter Review",
    referral_open: "Referral Open",
    refer_higher_authority: "Refer Higher Authority",
    auth_rejected: "Auth Rejected",
    node_error: "Node Error",
    unverifiable: "Not Signed by Node",
};

export default function StatusChip({ status, label, testId, className = "" }) {
    if (!status) return null;
    const style = STATUS_STYLES[status] || "bg-parchment-secondary text-ink-muted border-parchment-rule";
    const text = label || LABEL_OVERRIDES[status] || status.replace(/_/g, " ");
    return (
        <span
            className={`status-chip ${style} ${className}`}
            data-testid={testId || `status-chip-${status}`}
        >
            {text}
        </span>
    );
}
